import React from 'react';
import {
  useParams,
} from 'react-router-dom';
import StaticPageForm from '../components/static-page-form';
import Layout from '../components/layout';
import LinkButton from '../components/link-button';
import ButtonLink from '../components/button-link';
import PageHeader from '../components/page-header';
import './page.css';

const StaticPagePage = () => {
  const { id } = useParams();

  return (
    <Layout>
      <div className="page">
        <PageHeader
          title={`${id ? 'Modifier' : 'Créer'} une page statique`}
        />

        <div className="page_actions">
          <LinkButton
            className="page_action-button"
            icon="arrow_back"
            label="Retour"
            to="/pages-statiques"
            theme="danger"
          />

          {id &&
            <ButtonLink
              className="page_action-button"
              icon="remove_red_eye"
              label="Voir en ligne"
              href={`${process.env.REACT_APP_API_HOST}/page/${id}`}
              theme="info"
              target="_blank"
            />
          }
        </div>

        <StaticPageForm id={parseInt(id, 10)} />
      </div>
    </Layout>
  );
};

export default StaticPagePage;
